// extracted by mini-css-extract-plugin
export default {"lightBox":"LightBox__lightBox--37u","layer":"LightBox__layer--2Cr","layout":"LightBox__layout--w8P","popup":"LightBox__popup--GQx"};